// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"InterestLabel__iconWrapper___37eiK","icon":"InterestLabel__icon___3QxVI","label":"InterestLabel__label___2hLOZ"};